import { utilitiesMixin } from "./utilitiesMixin";
/**
 * File that can be loaded in each page as a mixin, handles generic stuff for axios calls
 */
export const dialogMixin = {
    mixins: [
        utilitiesMixin
    ],
    data() {
        return {
            dialog: false,
            newItem: true,
            disabled: false,
            currentObject: {}
        }
    },
    methods: {
        async save() {
            try{
                if(this.disabled){
                   return;
                }

                this.disabled = true;

                if(!this.hasChange()) {
                    this.$refs["alert"].showAlert("error", "Er is geen aanpassing gedaan voor dit object.");
                    this.disabled = false;
                    return;
                }

                let errorArray = this.checkObject(this.editedObject);
                if (errorArray.length !== 0) {
                    this.$refs["alert"].showAlertArray("error", errorArray);
                    this.disabled = false;
                } else {
                    this.loading = true;
                    //If a new item create otherwise update
                    (this.newItem) ? await this.create(this.editedObject) : await this.update(this.editedObject, this.currentObject)
                    await this.getData();
                    this.close();
                }
            }
            catch(err){
                this.$refs["alert"].showAxiosErrorAlert(err);
                setTimeout(() => this.disabled = false, 1000);
            }
        },
        close() {
            this.dialog = false;
            this.editedObject =  this.deepCopy(this.emptyObject);
            this.newItem = false;
            this.errors =[];
            this.$refs["alert"].closeAlert();
        },
        editObject(item) {
            this.currentObject = item;
            this.newItem = false;
            this.editedObject = this.deepCopy(item);
            this.dialog = true;
        },
        newObject() {
            this.newItem = true;
            this.editedObject = this.deepCopy(this.emptyObject);
            this.dialog = true;
        },
        /**
         * Function checks whether the objects has a change. It does _not_ do
         * this deeply, but only on the first level keys.
         *
         * @returns true if the object has a change or false if it does not.
         */
        hasChange() {
            let objectHasChange = false;

            for(const key of Object.keys(this.editedObject)) {
                /**
                 * The requested key contains the version object. We do not
                 * need to check this as this has to be the same. Checking it
                 * would make this function much more complex as we would need
                 * to compare the objects deeply.
                 */
                if(key === 'requested') {
                    continue;
                }

                if(!this.compareValues(this.currentObject[key], this.editedObject[key])) {
                    objectHasChange = true;
                    break;
                }
            }

            return objectHasChange;
        }
    },
    //These watch values for changes
    watch: {
        dialog(val) {
           if(val === true){
                this.disabled = false;
           }
        },
    }
}